var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Umsjá Dómsdags")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/dummy/episode/edit-meta"}},[_vm._v("Breyta upplýsingum þáttar")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/dummy/topic/add"}},[_vm._v("Búa til umræðuefni")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553bd262","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminMain.vue
// module id = null
// module chunks = 